module.exports = __webpack_public_path__ + "img/qrcode_b.55f3912d.jpg";